import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const interest = {
  fetchInterests: lazyModuleMethod(() => import('./fetchInterests'), 'default'),
  deleteInterest: lazyModuleMethod(() => import('./deleteInterest'), 'default'),
  createInterest: lazyModuleMethod(() => import('./createInterest'), 'default'),
}
